import { CardFaceImage } from "./CardFaceImage";
import { CardSyntheticFace } from "./CardSyntheticFace";
import { DeckOverlayButtons } from "./DeckOverlayButtons";
import { StatPill } from "./StatPill";

export function CardTile({ card, onOpen, signedIn, deckQuantity, onDeckAdd, onDeckRemove }) {
  const qty = deckQuantity ?? 0;

  return (
    <div className="group flex w-full flex-col overflow-hidden rounded-lg border border-slate-700 bg-slate-900 text-left shadow transition hover:border-amber-600/60 hover:shadow-lg">
      <div className="relative w-full shrink-0">
        {card.image_url ? (
          <>
            <CardFaceImage
              card={card}
              src={card.image_url}
              alt=""
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <button
              type="button"
              className="absolute inset-0 z-[1] cursor-pointer rounded-t-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
              aria-label={`View ${card.name}`}
              onClick={() => onOpen(card.id)}
            />
            <DeckOverlayButtons
              quantity={qty}
              signedIn={signedIn}
              onAdd={onDeckAdd}
              onRemove={onDeckRemove}
            />
          </>
        ) : (
          <div className="relative w-full">
            <CardSyntheticFace card={card} variant="tile" className="rounded-none border-slate-700/60" />
            <button
              type="button"
              className="absolute inset-0 z-[1] cursor-pointer rounded-t-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
              aria-label={`View ${card.name}`}
              onClick={() => onOpen(card.id)}
            />
            <DeckOverlayButtons
              quantity={qty}
              signedIn={signedIn}
              onAdd={onDeckAdd}
              onRemove={onDeckRemove}
            />
          </div>
        )}
      </div>
      <button
        type="button"
        className="flex flex-1 flex-col gap-1 p-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-500"
        onClick={() => onOpen(card.id)}
      >
        <h3 className="line-clamp-2 font-semibold leading-snug text-slate-100">{card.name}</h3>
        <div className="flex flex-wrap gap-1">
          {card.type_name && <StatPill>{card.type_name}</StatPill>}
          {card.sphere_name && <StatPill>{card.sphere_name}</StatPill>}
          {(card.cost != null && card.cost !== "") && <StatPill>Cost {card.cost}</StatPill>}
          {(card.threat != null && card.threat !== "") && <StatPill>Threat {card.threat}</StatPill>}
        </div>
        {card.traits && (
          <p className="line-clamp-2 text-xs text-slate-400">{card.traits}</p>
        )}
        {card.keywords && (
          <p className="line-clamp-2 text-xs text-amber-200/80">{card.keywords}</p>
        )}
      </button>
    </div>
  );
}
